export const actionChangeInputsPageComplaint = (name,value) => ({
    type: 'CHANGE_INPUTS_PAGE_COMPLAINT',name,value
});